import VueECharts from 'vue-echarts'

// ECharts tree-shaking (required by vue-echarts v7+/echarts v5+)
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import {
    BarChart,
    CustomChart,
    HeatmapChart,
    LineChart,
    ScatterChart,
    PieChart,
} from 'echarts/charts'
import {
    GridComponent,
    TooltipComponent,
    TitleComponent,
    LegendComponent,
    DataZoomComponent,
    DatasetComponent,
    TransformComponent,
    VisualMapComponent,
} from 'echarts/components'

use([
    CanvasRenderer,
    BarChart,
    CustomChart,
    ScatterChart,
    HeatmapChart,
    LineChart,
    PieChart,
    GridComponent,
    TooltipComponent,
    TitleComponent,
    LegendComponent,
    DataZoomComponent,
    DatasetComponent,
    TransformComponent,
    VisualMapComponent,
])

// Keep legacy templates working: <v-chart ... />
export default function useECharts(app) {
    app.component('VChart', VueECharts)
}
